import React, { useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import AmpLoadingSpinner from "../../components/common/AmpLoadingSpinner/AmpLoadingSpinner";
import LookingTodoNext from "../../components/landing/LookingTodoNext/LookingTodoNext";
import Notice from "../../components/rfr/Notice/Notice";
import { RootState } from "../../redux/reducers/root";
import { getRfrNotices } from "../../redux/actions/rfr/rfr";
import { RfrNoticesState } from "../../redux/reducers/getRfrReducer/rfrNoticesReducer";
import { FileRfrState } from "../../redux/reducers/getRfrReducer/fileRfrReducer";

import "./RfRLanding.css";

export default function RfRLanding(): JSX.Element {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentProperty = window.localStorage.getItem("currentProperty");
    const { t } = useTranslation("rfr");
    const { state } = useLocation();

    const fileresult = useSelector((state: RootState) => state.rfrReducer.filerfr as FileRfrState);
    const fetchresult = useSelector((state: RootState) => state.rfrReducer.getnotices as RfrNoticesState);

    const noservicemsg = t("rfr.notices.noservice");
    const [notices, setNotices] = useState(null);
    const [fetched, setFetched] = useState(false);
    const [expecting, setExpecting] = useState(false);
    const [message, setMessage] = useState("");

    if (expecting && (true === fetchresult.success || true === fetchresult.error)) {
        setFetched(true);
        if (true === fetchresult.success) {
            if (fetchresult.status === 200) {
                setNotices(fetchresult.notices);
                // } else if (fetchresult["status"] == 401) {
                //     navigate("/amp/signout", { replace: true });
            } else {
                setMessage(fetchresult.message);
            }
        } else if (true === fetchresult.error) {
            setMessage(noservicemsg);
        }
        setExpecting(false);
    }

    useEffect(() => {
        const fetchNotices = () => {
            dispatch(getRfrNotices(currentProperty));
            setExpecting(true);
            fileresult.torfrform = false;
        };
        if (!fetched) {
            fetchNotices();
        }
    }, [currentProperty, dispatch, fileresult, fetched]);

    useEffect(() => {
        const navigateToForm = () => {
            navigate("/amp/rfr/rfrform", {
                // replace: true,
                state: fileresult.response
            });
        };

        if (fileresult.torfrform === true) {
            navigateToForm();
            fileresult.torfrform = false;
        }
    }, [fileresult, navigate]);

    return (
        <>
            <div className="rfr-landing">
                <h1>{t("rfr.landing.title1")}</h1>
                <p>{t("rfr.landing.content-1-1")}</p>
                <p>{t("rfr.landing.content-1-2")}</p>
                <p>{t("rfr.landing.content-1-3")}</p>
                <p>{t("rfr.landing.content-1-4")}</p>
                <h1>{t("rfr.landing.title2")}</h1>
                <p>{t("rfr.landing.content-2-1")}</p>
                <p>{t("rfr.landing.content-2-2")}</p>
                <p>{t("rfr.landing.content-2-3")}</p>
                <p></p>

                <div className="rfr-notice-table-container">
                    <AmpLoadingSpinner loading={fetchresult.loading || fileresult.loading}>
                        <table className="rfr-notice-table">
                            <thead className="rfr-notice-table-border">
                                <tr className="rfr-notice-table-border">
                                    <th className="rfr-notice-name" id="rfr-notice-name">{t("rfr.notices.title.notices")}</th>
                                    <th className="rfr-notice-link" id="rfr-notice-link">{t("rfr.notices.title.viewnotice")}</th>
                                    <th className="rfr-notice-date" id="rfr-notice-date">{t("rfr.notices.title.dateissued")}</th>
                                    <th className="rfr-notice-deadline" id="rfr-notice-deadline">{t("rfr.notices.title.rfrdedline")}</th>
                                    <th className="rfr-notice-status" id="rfr-notice-status">{t("rfr.notices.title.status")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    fetched ?
                                        (
                                            notices ?
                                                (
                                                    notices.length === 0 ?
                                                        (
                                                            <tr>
                                                                <td colSpan={5} className="rfr-notice-na" headers="rfr-notice-name">
                                                                    <FontAwesomeIcon icon={faCircleExclamation} size="5x" className="rfr-notice-na-icon" />
                                                                    <h2>
                                                                        <Trans  defaults={t("rfr.notices.nonotices")}>
                                                                            <Link className="amp-anchor" target="_blank" rel="noopener noreferrer"></Link>
                                                                            <p></p>
                                                                        </Trans>
                                                                    </h2>
                                                                </td>
                                                            </tr>
                                                        )
                                                        :
                                                        (
                                                            notices.map((notice, key) => <Notice key={key} notice={notice} state={state} />)
                                                        )
                                                )
                                                :
                                                (
                                                    <tr>
                                                        <td colSpan={5} className="rfr-notice-na">
                                                            <FontAwesomeIcon icon={faCircleExclamation} size="5x" className="rfr-notice-na-icon" />
                                                            <h2>{message}</h2>
                                                        </td>
                                                    </tr>
                                                )
                                        )
                                        :
                                        (
                                            <tr>
                                                <td colSpan={5} className="rfr-notice-na">
                                                </td>
                                            </tr>
                                        )
                                }
                            </tbody>
                        </table>
                    </AmpLoadingSpinner>
                </div>

                <div className="home-landing-2">
                    <LookingTodoNext boxes={["vmpd", "bmn"]} />
                </div>
            </div>
        </>
    )
}